module.exports = __webpack_public_path__ + "static/media/mo.0dc09f49.svg";